export const DEFAULT_ACCENT = "#db146d";

const HEX6 = /^#[0-9a-fA-F]{6}$/;

export function normalizeAccent(hex: string | null | undefined): string {
  if (hex && HEX6.test(hex)) return hex.toLowerCase();
  return DEFAULT_ACCENT;
}

function hexRgb(hex: string): [number, number, number] {
  const n = parseInt(hex.replace("#", ""), 16);
  return [(n >> 16) & 255, (n >> 8) & 255, n & 255];
}

export function hexToRgba(hex: string, alpha: number): string {
  const [r, g, b] = hexRgb(hex);
  return `rgba(${r},${g},${b},${alpha})`;
}

export function accentIsLight(hex: string): boolean {
  const [r, g, b] = hexRgb(hex);
  return (r * 299 + g * 587 + b * 114) / 1000 > 150;
}

export function accentTint(hex: string, alpha: number = 0.09): string {
  return hexToRgba(hex, alpha);
}

export function onAccentFor(hex: string): string {
  return accentIsLight(hex) ? "#1a1d24" : "#ffffff";  // was "#222222"
}
